import { Post, Section } from "../common/types/post.types";
import { BreadCrumbContent } from "../common/types/common.types";
import { getAllPostsApi, getPostDetailApi } from "./api";
import { GetAllPostApiType, ResponsePaginationType } from "../common/types/api.types";

const domain = process.env.REACT_APP_SERVER_DOMAIN;

export function formatCode(data: string) {
  return data.replace(/\r\n/g, "\n");
}

export function formatJson(data: string) {
  return JSON.stringify(JSON.parse(data), undefined, 2);
}

export function getFormattedCode(language: string, content: string) {
  return language === "json" ? formatJson(content) : formatCode(content);
}

/**
 * Format paragraph
 * @param data
 */
export function formatParagraph(data: string) {
  // Inline code
  data = data.replace(new RegExp('\\(inlineCode\\)', 'g'), '<span class="inline-code">')
  data = data.replace(new RegExp('\\(/inlineCode\\)', 'g'), '</span>')
  return data;
}

export function getSections(sectionTree: string[], sections: Section[]): Section | null {
  if (sectionTree.length === 0) {
    return null;
  }

  const parentPath = sectionTree.shift();
  let sectionData = sections.find((item: any) => item.path === parentPath);

  if (!sectionData) {
    return null;
  }

  while (sectionTree.length !== 0) {
    const currentPath = sectionTree.shift();
    const data: Section | null = sectionData?.sub_sections?.find((sectionData: any) => sectionData.path === currentPath);

    if (!data) {
      return null;
    }

    sectionData = data;
  }

  return sectionData;
}

export async function getAllPost(params: GetAllPostApiType, sectionTree: string[]): Promise<ResponsePaginationType<any>> {
  if (sectionTree.length === 0) {
    return null;
  }

  params = {
    ...params,
    parent_path: sectionTree.join('/'),
  }

  return await getAllPostsApi(params);
}

export async function getSinglePost(id: number): Promise<Post> {
  return await getPostDetailApi(id)
}

export function getSectionInfoForPostBrief(postSectionTree: string[], currentSectionTree: string[], sections: Section[]): Section {
  if (postSectionTree.length === currentSectionTree.length) {
    return getSections(postSectionTree, sections);
  }

  if (postSectionTree.length < currentSectionTree.length) {
    return getSections(postSectionTree, sections);
  }

  return getSections(postSectionTree.slice(0, currentSectionTree.length + 1), sections);
}

/**
 * Generate breadcrumb for post detail
 * @param subSections
 * @param sections
 */
export function generateBreadcrumbsForPost(subSections: string[], sections: Section[]) {
  const breadcrumbs: BreadCrumbContent[] = [];
  for(let i = 0; i < subSections.length; ++i) {
    const sectionTree = subSections.slice(0, i + 1);
    const sectionData = getSections([...sectionTree], sections);

    if (!sectionData) {
      continue;
    }

    breadcrumbs.push({
      href: `/sections/${sectionTree.join('/')}`,
      name: sectionData.name,
      icon: getImageUrl(sectionData.icon)
    })
  }

  return breadcrumbs;
}

export async function getTopTrending(): Promise<Post[]> {
  const res = await getAllPostsApi({page: 1, limit: 6, order_by: 'view_count', order: 'DESC'});
  return res.data;
}

export function getImageUrl(relativePath: string): string {
  return `${domain}${relativePath}`
}
